export function disableConsoleInProduction() {
  const methods: (keyof Console)[] = ['log', 'debug', 'warn', 'info', 'error'];

  if (process.env.VUE_APP_MODE === 'PROD') {
    methods.forEach((method) => {
      (console[method] as unknown) = () => {};
    });
  }
}
